import { render, staticRenderFns } from "./ModalOrPopup.vue?vue&type=template&id=31e5551e&"
import script from "./ModalOrPopup.vue?vue&type=script&lang=ts&"
export * from "./ModalOrPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports